var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isLoaded)?_c(_setup.WorkspaceViewPage,{attrs:{"workspace":_setup.workspace,"sharedArticle":_setup.sharedArticle,"text-tab-slug":_vm.textTabSlug}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }